import React from "react";
import { useTranslation } from "react-i18next";

const RED_BRAND = "#E63946";

const WESHARE_URL =
  "https://www.wesharegiving.org/app/giving/WeShare-20000105?tab=home";
const CARDINALS_APPEAL_URL =
  "https://secure.archny.org/site/Donation2?df_id=6266&mfc_pref=T&6266.donation=form1&_ga=2.17607929.1924105313.1714405571-1169578734.1714234250&_gl=1*1xwzlxr*_ga*MTE2OTU3ODczNC4xNzE0MjM0MjUw*_ga_RDSS4X0HSG*MTcxNDQwNTU3MS4zLjAuMTcxNDQwNTU3OC4wLjAuMA..";

const NasDonationPageContent = () => {
  const { t } = useTranslation();

  const cards = [
    {
      icon: "fal fa-hands-heart",
      titleKey: "_community_support",
      descKey: "_community_support_desc",
    },
    {
      icon: "fal fa-bible",
      titleKey: "_religious_education",
      descKey: "_religious_education_desc",
    },
    {
      icon: "fal fa-church",
      titleKey: "_maintenance",
      descKey: "_maintenance_desc",
    },
  ];

  return (
    <>
      {/* ── Hero Section ── */}
      <div
        className="sigma_subheader dark-overlay dark-overlay-2"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/nas/backdrop_hsc.png)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: 320,
          display: "flex",
          alignItems: "center",
        }}
      >
        <div className="container">
          <div className="sigma_subheader-inner text-center" style={{ color: "#fff" }}>
            <h6
              className="subtitle cursive-style"
              style={{ color: "rgba(255,255,255,0.8)", marginBottom: 8 }}
            >
              {t("_donation_page_subtitle")}
            </h6>
            <h1 style={{ color: "#fff", fontWeight: 800, marginBottom: 16 }}>
              {t("_make_donation")}
            </h1>
            <p style={{ color: "rgba(255,255,255,0.85)", maxWidth: 600, margin: "0 auto", fontSize: "1.1rem" }}>
              {t("_donation_page_hero_desc")}
            </p>
          </div>
        </div>
      </div>

      {/* ── Why Donate Section ── */}
      <section className="section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
              <h6 className="subtitle cursive-style">{t("_why_donate")}</h6>
              <h4 className="title">{t("_donation_makes_difference")}</h4>
              <p style={{ color: "#666", lineHeight: 1.8 }}>
                {t("_donation_why_desc")}
              </p>
            </div>
          </div>

          <div className="row mt-5">
            {cards.map((item) => (
              <div className="col-md-4 text-center mb-4" key={item.titleKey}>
                <div
                  className="sigma_service style-6"
                  style={{
                    padding: "2rem 1.5rem",
                    borderRadius: 16,
                    border: "1px solid #f0f0f0",
                    height: "100%",
                  }}
                >
                  <div className="sigma_service-thumb" style={{ marginBottom: 16 }}>
                    <i className={item.icon} style={{ fontSize: 40, color: RED_BRAND }} />
                  </div>
                  <h5 style={{ fontWeight: 700, marginBottom: 8 }}>{t(item.titleKey)}</h5>
                  <p style={{ color: "#777", fontSize: "0.95rem", lineHeight: 1.7 }}>
                    {t(item.descKey)}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Donation Options Section ── */}
      <section
        className="section"
        style={{ backgroundColor: "#f8f8f8", paddingTop: 60, paddingBottom: 80 }}
      >
        <div className="container">
          <div className="row justify-content-center mb-5">
            <div className="col-lg-8 text-center">
              <h6 className="subtitle cursive-style">{t("_donation_options")}</h6>
              <h4 className="title">{t("_choose_contribution")}</h4>
            </div>
          </div>

          <div className="row justify-content-center">
            {/* ── WeShare Card ── */}
            <div className="col-lg-5 col-md-6 mb-4 mb-md-0">
              <div
                style={{
                  backgroundColor: "#fff",
                  borderRadius: 20,
                  boxShadow: "0 8px 40px rgba(0,0,0,0.08)",
                  padding: "2.5rem 2rem",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    width: 72,
                    height: 72,
                    borderRadius: "50%",
                    background: `linear-gradient(135deg, ${RED_BRAND}cc, ${RED_BRAND})`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: 20,
                    boxShadow: `0 8px 24px ${RED_BRAND}40`,
                  }}
                >
                  <i className="fal fa-church" style={{ fontSize: 28, color: "#fff" }} />
                </div>
                <h5 style={{ fontWeight: 800, marginBottom: 8, color: "#222" }}>
                  {t("_parish_donation")}
                </h5>
                <p style={{ color: "#777", lineHeight: 1.7, marginBottom: 24, flexGrow: 1 }}>
                  {t("_parish_donation_desc")}
                </p>
                <a
                  href={WESHARE_URL}
                  className="sigma_btn-custom"
                  rel="noreferrer"
                  target="_blank"
                  style={{ width: "100%", textAlign: "center" }}
                >
                  {t("_donate_via_weshare")}
                </a>
              </div>
            </div>

            {/* ── Cardinal's Appeal Card ── */}
            <div className="col-lg-5 col-md-6">
              <div
                style={{
                  backgroundColor: "#fff",
                  borderRadius: 20,
                  boxShadow: "0 8px 40px rgba(0,0,0,0.08)",
                  padding: "2.5rem 2rem",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                  borderTop: `4px solid ${RED_BRAND}`,
                }}
              >
                <div
                  style={{
                    width: 72,
                    height: 72,
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, #7a1a23, #b52530)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: 20,
                    boxShadow: "0 8px 24px rgba(122,26,35,0.35)",
                  }}
                >
                  <i className="fal fa-cross" style={{ fontSize: 28, color: "#fff" }} />
                </div>
                <h5 style={{ fontWeight: 800, marginBottom: 8, color: "#222" }}>
                  {t("_cardinals_campaign")}
                </h5>
                <p style={{ color: "#777", lineHeight: 1.7, marginBottom: 24, flexGrow: 1 }}>
                  {t("_cardinals_campaign_desc")}
                </p>
                <a
                  href={CARDINALS_APPEAL_URL}
                  className="sigma_btn-custom"
                  rel="noreferrer"
                  target="_blank"
                  style={{ width: "100%", textAlign: "center" }}
                >
                  {t("_donate_to_cardinals")}
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Scripture Quote ── */}
      <section
        className="section"
        style={{
          background: `linear-gradient(135deg, ${RED_BRAND}ee, #b52530)`,
          padding: "60px 0",
        }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-7 text-center">
              <i
                className="fal fa-quote-left"
                style={{ fontSize: 32, color: "rgba(255,255,255,0.4)", marginBottom: 16 }}
              />
              <h5
                style={{
                  color: "#fff",
                  fontStyle: "italic",
                  fontWeight: 400,
                  lineHeight: 1.7,
                  marginBottom: 16,
                }}
              >
                {t("_scripture_donation")}
              </h5>
              <p
                style={{
                  color: "rgba(255,255,255,0.7)",
                  fontSize: "0.9rem",
                  fontWeight: 600,
                  letterSpacing: 1,
                  marginBottom: 0,
                }}
              >
                {t("_scripture_ref_donation")}
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default NasDonationPageContent;
